<template>
  <comHomeView v-bind:items="items" v-if="mobile==false" />
  <comHomeViewMob v-bind:items="items" v-if="mobile==true" />
</template>

<script>
  import comHomeView from '../components/comHomeView.vue'
  import comHomeViewMob from '../components/comHomeViewMob.vue'

  export default {
    data () {
      return {
        items: [
          {
            src: require('../assets/Home/carousel1.jpg'),
          },
          {
            src: require('../assets/Home/carousel2.jpg'),
          },
          {
            src: require('../assets/Home/carousel3.jpg'),
          },
          {
            src: require('../assets/Home/carousel4.jpg'),
          },
        ],
        mobile: false,
        addressDetailsInpost: null,
                inpostName: null,
                inpostDescription: null
      }
    },
    components: { comHomeView, comHomeViewMob },
    created() {
      this.mobile = this.$vuetify.display.mobile
    },
  }
</script>
